import { render, staticRenderFns } from "./ConfirmarNuevoDestinatario.vue?vue&type=template&id=94a82b72&"
import script from "./ConfirmarNuevoDestinatario.vue?vue&type=script&lang=js&"
export * from "./ConfirmarNuevoDestinatario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports